import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { TarlV3JsonapiModule } from '®shared/tarl-v3-jsonapi';

import { UserResourceSubscriptionEffects } from './user-subscribed-resources.effects';
import { userResourceSubscriptionReducer } from './user-subscribed-resources.reducer';
import { UserSubscribedResourcesService } from './user-subscribed-resources.service';
import {
  STATE_USER_SUBSCRIBED_RESOURCES,
  getInitialUserResourceSubscriptionState,
} from './user-subscribed-resources.state';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([UserResourceSubscriptionEffects]),
    StoreModule.forFeature(
      STATE_USER_SUBSCRIBED_RESOURCES,
      userResourceSubscriptionReducer,
      {
        initialState: getInitialUserResourceSubscriptionState,
      },
    ),
    TarlV3JsonapiModule,
  ],
  providers: [UserSubscribedResourcesService],
})
export class UserSubscribedResourcesModule {}
